import { getApiUrlByEnvironment } from '@fitpet/constants-global'
import axios from 'axios'
import { isInAppFlag } from '@/utils/utilBridge'
import { localUserToken } from '@/utils/utilLocalStorage'

const httpRequest = axios.create({
  baseURL: getApiUrlByEnvironment(process.env.NEXT_PUBLIC_ENVIRONMENT).recommendation,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
})

const getUserToken = () => {
  if (typeof window !== 'undefined' && isInAppFlag) {
    return window.getToken().apiToken.token === '' ? undefined : window.getToken().apiToken
  } else {
    return localUserToken.load()
  }
}

const ApiRecommend = () => {
  const userToken = getUserToken()
  httpRequest.defaults.headers.common.authorization = userToken?.token

  return {
    httpRequest,
  }
}

export default ApiRecommend
